/**
 * @generated SignedSource<<b2ecf8db843196df853372b4b55823fd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type contentReactionDisplayQuery$data = {
  readonly upvote?: {
    readonly " $fragmentSpreads": FragmentRefs<"contentReactionDisplayUpvote">;
  } | null;
  readonly upvoteCount: {
    readonly count: number;
    readonly updatedAt: number;
  } | null;
  readonly " $fragmentType": "contentReactionDisplayQuery";
};
export type contentReactionDisplayQuery$key = {
  readonly " $data"?: contentReactionDisplayQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"contentReactionDisplayQuery">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "targetEntityId",
        "variableName": "entityId"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "entityId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isLoggedIn"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "contentReactionDisplayQuery",
  "selections": [
    {
      "alias": null,
      "args": (v0/*: any*/),
      "concreteType": "UpvoteCount",
      "kind": "LinkedField",
      "name": "upvoteCount",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "count",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updatedAt",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "condition": "isLoggedIn",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": (v0/*: any*/),
          "concreteType": "Upvote",
          "kind": "LinkedField",
          "name": "upvote",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "contentReactionDisplayUpvote"
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "4ec642e3f440911759baf1c7ebda0588";

export default node;
